export default {"src":"/_next/static/media/ic-pagination-prev.250c34b5.svg","height":15,"width":10,"blurWidth":0,"blurHeight":0};